export const SIDE_BAR_ACTION_ROUTE = 'api-task-manager';

export function getSideBarActionRoute(disruptionId: string) {
  return `/disruptions/${disruptionId}/${SIDE_BAR_ACTION_ROUTE}`;
}
